import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { OrderPaymentTransactionStatus } from '../../../../../../core/enums/commerce/payment/order-payment-transaction-status';

@Component({
    selector: 'app-payment-status-cell-renderer',
    templateUrl: './payment-status-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule],
})
export class PaymentStatusCellRendererComponent
    implements ICellRendererAngularComp
{
    status: OrderPaymentTransactionStatus | null = null;

    agInit(params: ICellRendererParams): void {
        this.status = params.value as OrderPaymentTransactionStatus;
    }

    refresh(): boolean {
        return false;
    }

    /**
     * Returns true if the payment status is one of the included in the success category, false otherwise.
     */
    isSuccess(): boolean {
        return (
            this.status === OrderPaymentTransactionStatus.Approved ||
            this.status === OrderPaymentTransactionStatus.Confirmed ||
            this.status === OrderPaymentTransactionStatus.Refunded
        );
    }

    /**
     * Returns true if the payment status is Pending, false otherwise.
     */
    isPending(): boolean {
        return this.status === OrderPaymentTransactionStatus.Pending;
    }

    /**
     * Returns true if the payment status is one of the included in the failure category, false otherwise.
     */
    isFailure(): boolean {
        return (
            this.status === OrderPaymentTransactionStatus.Declined ||
            this.status === OrderPaymentTransactionStatus.Voided ||
            this.status === OrderPaymentTransactionStatus.Failed ||
            this.status === OrderPaymentTransactionStatus.Unknown
        );
    }
}
